import {
  CapitalFormationConversionGradingCreateDocument,
  CapitalFormationConversionGradingDeleteDocument,
  CapitalFormationConversionGradingGetByIdDocument,
  CapitalFormationConversionGradingListPaginatedDocument,
  CapitalFormationConversionGradingUpdateDocument,
  CapitalFormationKpiDataConversionGradingListDocument,
} from "api/generated";
import { RequestTypes } from "api/services/enums";
import { getRequestInstance } from "api/services/utils";
import { PartialNullable } from "config";

import {
  IConversionGradingArgs,
  IConversionGradingModel,
  IConversionGradingReturnType,
  ICreateConversionGradingArgs,
  IUpdateConversionGradingArgs,
} from "./types";

export async function getConversionGrading(
  variables: IConversionGradingArgs
): Promise<IConversionGradingReturnType> {
  const makeRequest = getRequestInstance(RequestTypes.QUERY);
  const res = await makeRequest({
    query: CapitalFormationConversionGradingListPaginatedDocument,
    variables,
    fetchPolicy: "network-only",
  });

  return res?.data
    ?.capitalFormationConversionGradingListPaginated as IConversionGradingReturnType;
}

export async function getConversionGradingList(): Promise<
  IConversionGradingModel[]
> {
  const makeRequest = getRequestInstance(RequestTypes.QUERY);
  const res = await makeRequest({
    query: CapitalFormationKpiDataConversionGradingListDocument,
    fetchPolicy: "cache-first",
  });

  return (res?.data?.capitalFormationKpiDataConversionGradingList ??
    []) as IConversionGradingModel[];
}

export async function getConversionGradingById(
  id: number
): Promise<PartialNullable<IConversionGradingModel>> {
  const makeRequest = getRequestInstance(RequestTypes.QUERY);
  const res = await makeRequest({
    query: CapitalFormationConversionGradingGetByIdDocument,
    variables: {
      id,
    },
    fetchPolicy: "network-only",
  });

  return res?.data?.capitalFormationConversionGradingGetById;
}

export async function createConversionGrading(
  variables: ICreateConversionGradingArgs
): Promise<boolean> {
  const makeRequest = getRequestInstance(RequestTypes.MUTATE);
  const res = await makeRequest({
    mutation: CapitalFormationConversionGradingCreateDocument,
    variables,
    fetchPolicy: "no-cache",
  });

  return Boolean(res?.data?.capitalFormationConversionGradingCreate);
}

export async function updateConversionGrading(
  variables: IUpdateConversionGradingArgs
): Promise<boolean> {
  const makeRequest = getRequestInstance(RequestTypes.MUTATE);
  const res = await makeRequest({
    mutation: CapitalFormationConversionGradingUpdateDocument,
    variables,
    fetchPolicy: "no-cache",
  });

  return Boolean(res?.data?.capitalFormationConversionGradingUpdate);
}

export async function deleteConversionGrading(id: number): Promise<boolean> {
  const makeRequest = getRequestInstance(RequestTypes.MUTATE);
  const res = await makeRequest({
    mutation: CapitalFormationConversionGradingDeleteDocument,
    variables: {
      id,
    },
    fetchPolicy: "no-cache",
  });

  return Boolean(res?.data?.capitalFormationConversionGradingDelete);
}
